import { STEP_RAW_MATERIAL } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';

// ACTIONS
const rawActions = actionsFactory(STEP_RAW_MATERIAL);
const actions = { ...rawActions, ...thunkFactory(STEP_RAW_MATERIAL, '/etapamp/') };
export { actions };

// REDUCER
const initialState = {
  data: [],
  dataById: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

export default reducerFactory(STEP_RAW_MATERIAL, initialState);

// SAGAS
const sagas = sagasFactory(STEP_RAW_MATERIAL, '/etapamp/');
export { sagas };
